import { z } from 'zod';
import { lessonSchema } from './lesson.js';

export const learningPathLessonSchema = z.object({
  order: z.number().int(),
  lessonId: z.string(),
  lesson: lessonSchema,
});
export type LearningPathLesson = z.infer<typeof learningPathLessonSchema>;

export const learningPathSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type LearningPath = z.infer<typeof learningPathSchema>;

export const learningPathWithLessonsSchema = learningPathSchema.extend({
  learningPathLessons: z.array(learningPathLessonSchema),
});
export type LearningPathWithLessons = z.infer<typeof learningPathWithLessonsSchema>;

export const createLearningPathOptionsSchema = z.object({
  name: z.string(),
  lessons: z.array(
    z.object({
      lessonId: z.string(),
      order: z.number().int(),
    }),
  ),
});
export type CreateLearningPathOptions = z.infer<typeof createLearningPathOptionsSchema>;

export const updateLearningPathOptionsSchema = z.object({
  name: z.string(),
  lessons: z.array(
    z.object({
      lessonId: z.string(),
      order: z.number().int(),
    }),
  ),
});

export type UpdateLearningPathOptions = z.infer<typeof updateLearningPathOptionsSchema>;
export const GetLearningPathResultsSchema = z.object({
  learningPaths: z.array(learningPathWithLessonsSchema),
});
export type GetLearningPathResults = z.infer<typeof GetLearningPathResultsSchema>;
